export const forgivenessStageMessagingSelector = (state) => ({
  advanceIds: state.entities.advances.allIds,
  apiUrl: state.config.apiUrl,
  country: state.country.country,
  forgivenessById: state.entities.loanForgiveness.byId,
  portalRedesignEnabled: state.config.portalRedesignEnabled,
});
